import React, { useState } from 'react'
import Cookies from "js-cookie"
import { useGetShopReportDetails } from '../../../API_Master/GetAPI';
import { useSelector } from 'react-redux';
import DetailsActionHistoryReport from './DetailsActionHistoryReport';
import dayjs from 'dayjs';
const ActionHistory = () => {
    const { shopDetailID } = useSelector(state => state.ProjectSlice)
     const startDate = dayjs().subtract(7, 'day').format('DD-MM-YYYY');
      const endDate = dayjs().format('DD-MM-YYYY')
    const { data: myShopReportDetails = [] } = useGetShopReportDetails(shopDetailID,startDate,endDate);
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                    <span className="material-symbols-outlined text-primary">warning</span>
                    Action History ( Last 7 days)
                </h3>
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition text-sm font-medium"
                >
                    View Detailed Report
                </button>
            </div>
            <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-6 flex-1">
                {myShopReportDetails.length === 0 ? (
                    <div className="text-center text-slate-500 dark:text-slate-400 py-8">
                        No reports or actions yet
                    </div>
                ) : (
                    <ul className="-mb-8" role="list">
                        {myShopReportDetails.map((report, i) => (
                            <li key={i}>
                                <div className="relative pb-8">
                                    {i < myShopReportDetails.length - 1 && (
                                        <span aria-hidden="true" className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-slate-200 dark:bg-slate-700" />
                                    )}
                                    <div className="relative flex space-x-3">
                                        <div>
                                            <span className="h-8 w-8 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center ring-4 ring-white dark:ring-slate-900">
                                                <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-sm">priority_high</span>
                                            </span>
                                        </div>
                                        <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                                            <div>
                                                <p className="text-sm text-slate-900 dark:text-white font-semibold capitalize">
                                                    {report.Title}
                                                </p>
                                                <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                                                    {report.Description}
                                                </p>
                                                {/* <p className="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                                    Status: <span className="font-medium">{report.Status}</span>
                                                </p> */}
                                            </div>
                                            <div className="whitespace-nowrap text-right text-xs text-slate-500 dark:text-slate-400">
                                                <time>{report.ReportDate + " " + report.ReportTime} </time>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            {isModalOpen && (
                <DetailsActionHistoryReport setIsModalOpen={setIsModalOpen} />
            )}
        </div>
    )
}

export default ActionHistory
